import axios from '@axios'

const PREFIX = '/painel-proposta'

const PREFIX_PROPOSTA = '/propostas'

export default {

  getPropostas(filtros, manual) {
    return axios.post(`${PREFIX}?manual=${manual}`, filtros)
  },

  getFiltroIniciais() {
    return axios.get(`${PREFIX}/filtros-iniciais`)
  },

  getEtiquetas(filtros) {
    return axios.post(`${PREFIX}`, filtros)
  },

  getPlanilhaPropostas(filtros) {
    return axios.post(`${PREFIX}/relatorio`, filtros)
  },
  getPlanilhaFinanceiro(datas) {
    return axios.post(`${PREFIX_PROPOSTA}/gera-planilha`, datas)
  },
  deleteUpload(nomeArquivo) {
    return axios.delete(`${PREFIX_PROPOSTA}/delete-upload?arquivo=${nomeArquivo}`)
  },

  getDadosColunas(coluna, filtros) {
    return axios.post(`${PREFIX}/filtro-coluna?coluna=${coluna}`, filtros)
  },
}
